import {
  developerFileSrc,
  getDeveloperProfile,
  loadDeveloperAvatar,
  type DeveloperProfile,
} from '@/api/developer'
import { useUserStore, type DeveloperProfileState } from '@/store/useUserStore'

let inflight: Promise<void> | null = null

export function profileUserAvatar(profile: DeveloperProfile, displayAvatar: string): string {
  if (!profile.avatarUrl) return profile.imAvatarUrl
  if (displayAvatar.startsWith('blob:')) return developerFileSrc(profile.avatarUrl)
  return displayAvatar
}

export function toStoredProfile(
  profile: DeveloperProfile,
  displayAvatar: string,
): DeveloperProfileState {
  return { ...profile, displayAvatar }
}

/** 本次会话只请求一次 GET /developer/profile。失败后不再自动重试。 */
export function ensureDeveloperProfile(): Promise<void> {
  if (inflight) return inflight
  const status = useUserStore.getState().profileStatus
  if (status === 'ready' || status === 'error' || status === 'loading') {
    return Promise.resolve()
  }

  useUserStore.setState({ profileStatus: 'loading' })
  inflight = (async () => {
    try {
      const profile = await getDeveloperProfile()
      const displayAvatar = await loadDeveloperAvatar(profile)
      if (!useUserStore.getState().isAuthenticated) {
        if (displayAvatar.startsWith('blob:')) URL.revokeObjectURL(displayAvatar)
        if (useUserStore.getState().profileStatus === 'loading') {
          useUserStore.setState({ profileStatus: 'idle' })
        }
        return
      }
      useUserStore
        .getState()
        .applyDeveloperProfile(
          toStoredProfile(profile, displayAvatar),
          profileUserAvatar(profile, displayAvatar),
        )
    } catch {
      if (useUserStore.getState().profileStatus === 'loading') {
        useUserStore.setState({ profileStatus: 'error' })
      }
    } finally {
      inflight = null
    }
  })()
  return inflight
}
